"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Field_1 = require("../Field");
var typography_1 = require("../../../typography");
var Icon_1 = __importDefault(require("../../../basics/Icon"));
var HorizontalSpacer_1 = __importDefault(require("../../../utils/HorizontalSpacer"));
var styles_1 = require("./styles");
var ICON_SIZE = { small: 24, medium: 24, large: 24 };
var CheckboxInput = function (_a) {
    var ariaLabel = _a.ariaLabel, id = _a.id, props = __rest(_a, ["ariaLabel", "id"]);
    var handleKeyPress = function (e) {
        e.persist();
        if (e.currentTarget === document.activeElement) {
            props.onChange(!props.value);
        }
    };
    return (react_1.default.createElement(Field_1.Field, { id: id, label: props.label, required: props.required, error: props.error, hint: props.hint },
        react_1.default.createElement(HorizontalSpacer_1.default, { "data-component-name": "CheckboxInput", id: id, amount: { small: 12, medium: 16, large: 16 } },
            react_1.default.createElement(styles_1.Input, { error: props.error, disabled: props.disabled, role: "checkbox", "aria-label": ariaLabel, "aria-checked": props.value ? 'true' : 'false', onClick: props.disabled
                    ? undefined
                    : function () {
                        props.onChange(!props.value);
                    }, onBlur: props.onBlur, tabIndex: props.disabled ? undefined : 0, onKeyPress: handleKeyPress }, props.value && (react_1.default.createElement(Icon_1.default, { name: "check", color: props.disabled ? 'GREY_70' : 'BLUE_50', size: ICON_SIZE }))),
            props.children && (react_1.default.createElement(typography_1.Body, { level: "3", inline: true, color: props.disabled ? 'GREY_70' : 'GREY_90' }, props.children)))));
};
exports.default = CheckboxInput;
